export default __webpack_public_path__ + "static/media/S.68f92029.gif";